import { createSelector } from '@reduxjs/toolkit';

import { selectReadyBusinessTypes } from 'shared/selectors/jsonQuery';

import { selectReadyBusinessTypesLabel } from './selectReadyBusinessTypesLabel';
import { READY_BUSINESS_TYPES_OPTIONS } from './selectReadyBusinessTypesOptions';

export const selectReadyBusinessTypesFilter = createSelector(
  [selectReadyBusinessTypes, selectReadyBusinessTypesLabel],
  (value, label) => ({
    label,
    value: value ?? [],
    options: READY_BUSINESS_TYPES_OPTIONS,
  }),
);
